import modalShopDeleted from "./modalShopDeleted"
export default modalShopDeleted;
